import React, { useState } from "react";
import EmailIcon from "@mui/icons-material/Email";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import axios from "axios";
import { API_PWD_RESET } from "../constants";

function ForgotPasswordResend({ email, setPasswordResetFlow }) {
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [resendError, setResendError] = useState("");

  const handleResendEmail = async () => {
    if (resending || !email) return;
    setResending(true);
    setResendMessage("");
    setResendError("");
    try {
      await axios.post(API_PWD_RESET, { email });
      setResendMessage("Sent! Check your email again.");
    } catch (error) {
      const status = error?.response?.status;
      if (status === 429) {
        setResendError(
          "Too many resend attempts. Please wait an hour and try again."
        );
      } else {
        setResendError(
          "Couldn't resend the email. Please try again in a few minutes."
        );
      }
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <div className="w-96 flex flex-col items-center justify-center">
        <div className="h-24 w-24 bg-violet-50 flex items-center justify-center rounded-full">
          <div className="h-16 w-16 bg-violet-100 flex items-center justify-center rounded-full text-violet-700">
            <EmailIcon style={{ fontSize: 40 }} />
          </div>
        </div>
        <div className="mt-5 flex flex-col justify-center items-center">
          <h3 className="text-4xl text-slate-900">Check Your Email</h3>
          <p className="text-slate-500 mt-8 text-lg">
            We sent account access instructions to:
          </p>
          <p className="text-slate-900 mt-2 text-xl font-bold">{email}</p>
        </div>
        <p className="text-slate-500 mt-8 text-center text-base">
          Open your email and follow the instructions to continue.
        </p>
        <div className="mt-7 text-center">
          <p
            className={
              resending
                ? "text-slate-400 cursor-not-allowed"
                : "text-slate-500 cursor-pointer"
            }
            onClick={handleResendEmail}
          >
            Didn't receive an email?{" "}
            <span className="text-primary">
              {resending ? "Resending…" : "Click to resend"}
            </span>
          </p>
          {resendMessage && (
            <p className="text-emerald-600 text-sm mt-2">{resendMessage}</p>
          )}
          {resendError && (
            <p className="text-rose-600 text-sm mt-2">{resendError}</p>
          )}
        </div>
        <button
          className="mt-4 py-4 px-6 text-slate-500 hover:text-slate-900"
          onClick={() => setPasswordResetFlow(0)}
        >
          <KeyboardBackspaceIcon /> Back to log in
        </button>
      </div>
    </div>
  );
}

export default ForgotPasswordResend;
